import { useLayoutEffect, useMemo, useRef, useState } from 'react';
import Loading from '../components/Loading';
import { usePractice } from '../providers/practices/PracticesProvider';
import { useUser } from '../providers/UserProvider';

const JOTFORM_BASE_URL = 'https://form.jotform.com/260682952102050';

const Shop: React.FC = () => {
    const { user } = useUser();
    const { practices } = usePractice();
    const containerRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<number | undefined>(undefined);
    const [isLoaded, setIsLoaded] = useState(false);

    useLayoutEffect(() => {
        function updateHeight() {
            if (!containerRef.current) return;
            const top = containerRef.current.getBoundingClientRect().top;
            setHeight(window.innerHeight - top);
        }

        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    const iframeSrc = useMemo(() => {
        const userId = user?.database?.data?.id ?? '';
        const practiceId = practices[0]?.id ?? '';
        const practiceName = (practices[0]?.name ?? '').replace(/ /g, '-');

        const params = new URLSearchParams({
            user_id: userId,
            practice_id: practiceId,
            practice_name: practiceName
        });
        return `${JOTFORM_BASE_URL}?${params.toString()}`;
    }, [user, practices]);

    return (
        <div ref={containerRef} className="w-full scrollbar-hide" style={{ height }}>
            {!isLoaded && <Loading />}
            <iframe
                src={iframeSrc}
                title="Shop"
                className={`w-full h-full border-0 ${isLoaded ? '' : 'invisible'}`}
                allow="geolocation; microphone; camera"
                onLoad={() => setIsLoaded(true)}
            />
        </div>
    );
};

export default Shop;
